<template>
  <div class="desktop-subheader">
    <div class="desktop-subheader__container mx-auto">
      <div class="desktop-subheader-title">
        {{ subheaderTitle }}
      </div>

      <div class="desktop-subheader-nav">
        <slot name="subheader-nav"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'desktop-subheader',

    props: {
      subheaderTitle: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style lang="scss">
  .desktop-subheader {
    background-color: #fff;

    .desktop-subheader__container {
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 40px;

      @media (min-width: 576px) {
        max-width: 540px;
      }

      @media (min-width: 768px) {
        max-width: 720px;
      }

      @media (min-width: 992px) {
        max-width: 960px;
      }
    }

    .desktop-subheader-title {
      font-size: 20px;
      font-weight: bold;
      line-height: 1.5;
      color: rgba(0, 0, 0, 0.87);
    }

    .desktop-subheader-nav {
      padding-top: 16px;
      height: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// DesktopSubheader.vue?5e9a952f